import React from 'react';
import { 
  FiCheckCircle, 
  FiClock, 
  FiDownload, 
  FiFileText, 
  FiPlusCircle, 
  FiCalendar, 
  FiUploadCloud, 
  FiBell, 
  FiBarChart2, 
  FiInfo 
} from 'react-icons/fi';
import { HiOutlineDocumentText } from 'react-icons/hi2';

export default function TrainingDashboardBottom() {
  const recentCompletions = [
    { id: 1, staff: 'Ahmed Raza', course: 'Knife Skills', date: '20 Apr 2026' },
    { id: 2, staff: 'Sara Khan', course: 'Customer Service', date: '19 Apr 2026' },
    { id: 3, staff: 'Usman Ali', course: 'HACCP', date: '15 Apr 2026' },
    { id: 4, staff: 'Laura Roberts', course: 'Barista Training', date: '18 Apr 2026' },
  ];

  const expiringSoon = [
    { id: 1, course: 'Food Safety Level 2', staffCount: '1 staff', date: '25 May 2026' },
    { id: 2, course: 'Allergens', staffCount: '1 staff', date: '22 May 2026' },
    { id: 3, course: 'Chemical Safety', staffCount: '1 staff', date: '30 May 2026' },
  ];

  const documents = [
    { id: 1, name: 'Training Policy', updated: 'Updated 10 May 2026' },
    { id: 2, name: 'Training Schedule 2026', updated: 'Updated 08 May 2026' },
    { id: 3, name: 'Induction Checklist', updated: 'Updated 02 May 2026' },
    { id: 4, name: 'Competency Assessment Form', updated: 'Updated 05 May 2026' },
  ];

  const quickActions = [
    { id: 1, text: 'Record Training Completion', icon: FiCheckCircle },
    { id: 2, text: 'Add Staff Training Session', icon: FiCalendar },
    { id: 3, text: 'Upload Certificate / Evidence', icon: FiUploadCloud },
    { id: 4, text: 'Send Training Reminder', icon: FiBell },
    { id: 5, text: 'View Training Reports', icon: FiBarChart2 },
  ];

  return (
    <div className="w-full bg-slate-50/50 p-4 font-sans text-slate-800">
      
      {/* 4-Column Responsive Dashboard Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        
        {/* Panel 1: Recent Training Completions */}
        <div className="bg-white border border-slate-200/80 rounded-xl shadow-sm flex flex-col justify-between overflow-hidden">
          <div>
            <div className="px-4 py-3 flex items-center justify-between border-b border-slate-100">
              <h3 className="text-xs font-bold text-slate-900">Recent Training Completions</h3>
              <button className="text-[11px] font-semibold text-blue-600 hover:underline">View all</button>
            </div>
            <div className="divide-y divide-slate-100 px-4">
              {recentCompletions.map((item) => (
                <div key={item.id} className="py-2.5 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-2 min-w-0">
                    <FiCheckCircle className="w-3.5 h-3.5 text-emerald-600 shrink-0" />
                    <span className="text-xs font-bold text-slate-800 truncate">{item.staff}</span>
                  </div>
                  <span className="text-xs text-slate-400 truncate max-w-[100px]">{item.course}</span>
                  <span className="text-[10px] text-slate-400 font-medium shrink-0 whitespace-nowrap">{item.date}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="p-3 border-t border-slate-100 bg-slate-50/20">
            <button className="text-xs font-bold text-blue-600 hover:underline">View all completions</button>
          </div>
        </div>

        {/* Panel 2: Expiring Soon */}
        <div className="bg-white border border-slate-200/80 rounded-xl shadow-sm flex flex-col justify-between overflow-hidden">
          <div>
            <div className="px-4 py-3 flex items-center justify-between border-b border-slate-100">
              <h3 className="text-xs font-bold text-slate-900">Expiring Soon</h3>
              <button className="text-[11px] font-semibold text-blue-600 hover:underline">View all</button>
            </div>
            <div className="divide-y divide-slate-100 px-4">
              {expiringSoon.map((item) => (
                <div key={item.id} className="py-2.5 flex items-center justify-between gap-4">
                  <div className="flex items-start gap-2.5 min-w-0">
                    <div className="w-7 h-7 bg-amber-50 border border-amber-100 rounded-lg flex items-center justify-center shrink-0">
                      <FiClock className="w-3.5 h-3.5 text-amber-500" />
                    </div>
                    <div className="flex flex-col min-w-0">
                      <span className="text-xs font-bold text-slate-800 truncate">{item.course}</span>
                      <span className="text-[10px] text-slate-400 font-medium">{item.staffCount}</span>
                    </div>
                  </div>
                  <span className="text-[10px] text-slate-400 font-medium shrink-0 whitespace-nowrap">{item.date}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="p-3 border-t border-slate-100 bg-slate-50/20">
            <button className="text-xs font-bold text-blue-600 hover:underline">View all expiring</button>
          </div>
        </div>

        {/* Panel 3: Training Documents */}
        <div className="bg-white border border-slate-200/80 rounded-xl shadow-sm flex flex-col justify-between overflow-hidden">
          <div>
            <div className="px-4 py-3 flex items-center justify-between border-b border-slate-100">
              <h3 className="text-xs font-bold text-slate-900">Training Documents</h3>
              <button className="text-[11px] font-semibold text-blue-600 hover:underline">Manage</button>
            </div>
            <div className="divide-y divide-slate-100 px-4">
              {documents.map((doc) => (
                <div key={doc.id} className="py-2.5 flex items-center justify-between gap-3">
                  <div className="flex items-start gap-2.5 min-w-0">
                    <HiOutlineDocumentText className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />
                    <div className="flex flex-col min-w-0">
                      <span className="text-xs font-bold text-slate-800 tracking-tight truncate">{doc.name}</span>
                      <span className="text-[10px] text-slate-400 font-medium">{doc.updated}</span>
                    </div>
                  </div>
                  <button className="p-1 text-slate-400 hover:text-slate-600 shrink-0 transition">
                    <FiDownload className="w-3.5 h-3.5" />
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="p-3 border-t border-slate-100 bg-slate-50/20">
            <button className="text-xs font-bold text-blue-600 hover:underline">View all documents</button>
          </div>
        </div>

        {/* Panel 4: Quick Actions */}
        <div className="bg-white border border-slate-200/80 rounded-xl shadow-sm overflow-hidden p-4 flex flex-col gap-2">
          <h3 className="text-xs font-bold text-slate-900 mb-1">Quick Actions</h3>
          {quickActions.map((action) => {
            const Icon = action.icon;
            return (
              <button 
                key={action.id} 
                className="w-full flex items-center gap-3 px-3 py-2 bg-white border border-slate-200/80 rounded-lg text-xs font-medium text-slate-700 shadow-sm hover:bg-slate-50 hover:border-slate-300 transition text-left"
              >
                <Icon className="w-3.5 h-3.5 text-slate-500 shrink-0" />
                <span className="truncate">{action.text}</span>
              </button>
            );
          })}
        </div>

      </div>

      {/* Bottom Legal / Compliance Status Line Footer */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-t border-slate-200/60 pt-4 px-1">
        <div className="flex items-start sm:items-center gap-2 text-xs text-slate-500 font-medium max-w-2xl leading-relaxed">
          <FiInfo className="w-4 h-4 text-slate-400 shrink-0 mt-0.5 sm:mt-0" />
          <span>Keep training records up to date. Ensuring your team is trained and competent helps you stay compliant and safe.</span>
        </div>

        <div className="flex items-center gap-4 text-xs font-bold text-blue-600 shrink-0">
          <button className="inline-flex items-center gap-1.5 hover:underline">
            <HiOutlineDocumentText className="w-4 h-4" />
            <span>Training Compliance Report</span>
          </button>
          <button className="inline-flex items-center gap-1.5 hover:underline">
            <HiOutlineDocumentText className="w-4 h-4" />
            <span>Audit Pack (Training)</span>
          </button>
        </div>
      </div>

    </div>
  );
}
